
/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Container } from "react-bootstrap";
import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";
import { CastType } from "../../../component/solution/Interfaces";

export const SalesInvoice: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">
                <QueryListProvider>
                    <QueryList
                        listTitle={"Sales Invoices"}
                        recordTitle={"Sales Invoice"}
                        tableName={"sa_sales_invoice"}
                        editTableName={"sa_purchase_invoice"}
                        editHasCompoundKey={false}
                        join={[]} 
                        select={[
                            {
                                fullColumnName: "customer_code",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "location",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "invoice_date",
                                aggregate: ""
                            },    
                            {
                                fullColumnName: "erp_invoice",
                                aggregate: ""
                            },                         
                            {
                                fullColumnName: "fixably_id",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "erp_updated",
                                aggregate: ""
                            },
                            {
                                fullColumnName: "created",
                                aggregate: ""
                            },                            
                            {
                                fullColumnName: "updated",
                                aggregate: ""
                            }                            
                        ]}
                        where={[
                            // {
                            //     fullColumnName: "is_base_item",
                            //     value: false,
                            //     operator: "EQ",
                            //     cast: CastType.BOOLEAN
                            // }
                        ]} 
                        orderBy={[    
                            {
                                fullColumnName: "created",
                                direction: "DESC",
                                cast: CastType.STRING
                            }
                    ]} 
                        groupBy={[]}                   
                    />
                </QueryListProvider>
            </Container>
        </React.Fragment>
    );
}